import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledActionsWrap = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'BOLD')};
      width: 100%;
      color: ${COLORS.WHITE};
    }
  }
`;
